import script from "./CalculatorsList.vue?vue&type=script&setup=true&lang=js"
export * from "./CalculatorsList.vue?vue&type=script&setup=true&lang=js"

import "./CalculatorsList.vue?vue&type=style&index=0&id=9b03a032&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b03a032"]])

export default __exports__